import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import * as actionArea from '@sitebase/pre-integrated-features/action-area';
import * as deposit from '@sitebase/pre-integrated-features/deposit';
import * as depositButton from '@sitebase/pre-integrated-features/deposit-button';
import * as depositComposite from '@sitebase/pre-integrated-features/deposit-composite';
import * as loginButton from '@sitebase/pre-integrated-features/login-button';
import * as logo from '@sitebase/pre-integrated-features/logo';
import * as productMenu from '@sitebase/pre-integrated-features/product-menu';
import * as registrationButton from '@sitebase/pre-integrated-features/registration-button';
import * as subNavEnd from '@sitebase/pre-integrated-features/sub-nav-end';
import * as subNavEndLanguageMenu from '@sitebase/pre-integrated-features/sub-nav-end-language-menu';
import * as subNavStart from '@sitebase/pre-integrated-features/sub-nav-start';
import * as info from '@sitebase/pre-integrated-features/info';

var renderers = [].concat(_toConsumableArray(actionArea.renderers), _toConsumableArray(deposit.renderers), _toConsumableArray(depositButton.renderers), _toConsumableArray(depositComposite.renderers), _toConsumableArray(loginButton.renderers), _toConsumableArray(logo.renderers), _toConsumableArray(productMenu.renderers), _toConsumableArray(registrationButton.renderers), _toConsumableArray(subNavEnd.renderers), _toConsumableArray(subNavEndLanguageMenu.renderers), _toConsumableArray(subNavStart.renderers), _toConsumableArray(info.renderers));

var initWorkflows = function initWorkflows(options) {
  depositComposite.initWorkflow(options);
  loginButton.initWorkflow();
  logo.initWorkflow();
  productMenu.initWorkflow();
  registrationButton.initWorkflow();
  subNavEndLanguageMenu.initWorkflow();
  subNavStart.initWorkflow();
};

export { renderers, initWorkflows, actionArea, deposit, depositButton, depositComposite, loginButton, logo, productMenu, registrationButton, subNavEnd, subNavEndLanguageMenu, subNavStart, info };
//# sourceMappingURL=index.js.map